import { TMortrageState } from 'shared/types/mortrage';
import { TApplicationState } from 'shared/types/redux';

export function selectMortrageInfo(state: TApplicationState): TMortrageState {
  return state.mortrageInfo;
}
